import NProgress from 'nprogress'

const tools = {}

tools.isEmpty = function(val) {
  return typeof val === 'undefined' || val == null || val === '' || val === 'null' || JSON.stringify(val) === '[]' || JSON.stringify(val) === '{}'
}

tools.endProgress = function () {
  NProgress.done()
}

tools.progress = function () {
  NProgress.start()
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, //月份  
    'd+': this.getDate(), //日  
    'h+': this.getHours(), //小时  
    'm+': this.getMinutes(), //分  
    's+': this.getSeconds(), //秒  
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度  
    'S': this.getMilliseconds()
    //毫秒  
  }
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '')
      .substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k])
        : (('00' + o[k]).substr(('' + o[k]).length)))
  return fmt
}

/**
 * 标准时间转换为日期格式
 * @param {string} timeStr
 * @param {string} format 格式化为日期或日期加时间
 * eg:Tue Jun 28 2022 15:30:29 GMT+0800 (中国标准时间) 转换为 2022-06-28 15:30:29
 */
 tools.str3FormatTime = function(timeStr, format, type = ''){
  let d = new Date(timeStr)
  let resMonth = d.getFullYear() + '.' + p((d.getMonth() + 1))
  let resDate = d.getFullYear() + '.' + p((d.getMonth() + 1)) + '.' + p(d.getDate())
  let reszhDate = d.getFullYear() + '年' + p((d.getMonth() + 1)) + '月' + p(d.getDate()) + "日"
  let resTime = p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds())
  if (!type) {
	  return format ==1 ? ( resDate + ' ' + resTime ) : format == 2 ? resMonth : format == 3 ? reszhDate : resDate
  } else {
	  if (type == 1) {
		  return d.getFullYear();
	  } else {
		  return  p((d.getMonth() + 1)) + '/' + p(d.getDate());
	  }
  } 
}

/**
 * 标准时间转换为日期格式
 * @param {string} timeStr
 * @param {string} format 格式化为日期或日期加时间
 * eg:Tue Jun 28 2022 15:30:29 GMT+0800 (中国标准时间) 转换为 2022-06-28 15:30:29
 */
 tools.str2FormatTime = function(timeStr, format, type = ''){
  let d = new Date(timeStr)
  let resMonth = d.getFullYear() + '-' + p((d.getMonth() + 1))
  let resDate = d.getFullYear() + '-' + p((d.getMonth() + 1)) + '-' + p(d.getDate())
  let reszhDate = d.getFullYear() + '年' + p((d.getMonth() + 1)) + '月' + p(d.getDate()) + "日"
  let resTime = p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds())
  if (!type) {
	  return format ==1 ? ( resDate + ' ' + resTime ) : format == 2 ? resMonth : format == 3 ? reszhDate : resDate
  } else {
	  if (type == 1) {
		  return d.getFullYear();
	  } else {
		  return  p((d.getMonth() + 1)) + '/' + p(d.getDate());
	  }
  } 
}
//不够10添加0的函数
function  p(s) {
  return s < 10 ? '0' + s : s
}

//yyyy-MM-dd hh:mm:ss
export function tableDateFormat(row, column) {
  if (row[column.property] == null || row[column.property] == '') {
    return 
  }
  if (row[column.property] != null) {
    return new Date(row[column.property]).Format('yyyy-MM-dd hh:mm:ss')
  }
  // var date = new Date(row[column.property]);
  // let month = date.getMonth() + 1;
  // let day = date.getDate();
  
  // let h = date.getHours();
  // let m = date.getMinutes();
  // let s = date.getSeconds();
  // return date.getFullYear() + '-' + (month < 10 ? ('0' + month) : month) + '-' + (day < 10 ? ('0' + day) :day)+ ' ' + + h + ':' + m + ':' + s
}


/**
 * 标准时间戳转换为几分钟前、几小时前的格式
 * @param {string} dateTimeStamp 时间戳
 * eg:1695283373847 转换为 2分钟前
 */
tools.timeago = function(dateTimeStamp, flag){
  var minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
  var hour = minute * 60;
  var day = hour * 24;
  var week = day * 7;
  var halfamonth = day * 15;
  var month = day * 30;
  var now = new Date().getTime(); //获取当前时间毫秒
  var diffValue = now - dateTimeStamp; //时间差
  if (diffValue < 0) {
      return '刚刚';
  }
  var minC = diffValue / minute; //计算时间差的分，时，天，周，月
  var hourC = diffValue / hour;
  var dayC = diffValue / day;
  var weekC = diffValue / week;
  var monthC = diffValue / month;
  var result = "2";
  // if (monthC >= 1 && monthC <= 3) {
  //     result = " " + parseInt(monthC) + "月前"
  // } else if (weekC >= 1 && weekC <= 4) {
  //     result = " " + parseInt(weekC) + "周前"
  // } else if (dayC >= 1 && dayC <= 6) {
  //     result = " " + parseInt(dayC) + "天前"
  // } else 
  if (hourC >= 1 && hourC <= 23) {
      result = " " + parseInt(hourC) + "小时前"
  } else if (minC >= 1 && minC <= 59) {
      result = " " + parseInt(minC) + "分钟前"
  } else if (diffValue >= 0 && diffValue <= minute) {
      result = "刚刚"
  } else {
      var datetime = new Date();
      datetime.setTime(dateTimeStamp);
      var Nyear = datetime.getFullYear(); {}
      var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
      var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
      var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
      var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
      var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
      result = flag ? Nyear + "-" + Nmonth + "-" + Ndate 
                    : Nyear + "-" + Nmonth + "-" + Ndate + " " + Nhour + ":" + Nminute + ":" + Nsecond
  }
  return result;
}

export default tools

